import { Injectable } from "@angular/core";

@Injectable()
// Class to hold common utility functions
export class common {
  // Method to redirect using deeplink URL
  deeplink(url: string) {
    // Check if the user agent is Android
    if (navigator.userAgent.match(/Android/i)) {
      // Open the URL in a new window for Android devices
      var win = window.open(url, "_blank");
    } else {
      // Redirect to the URL for other devices
      window.location.href = url;
    }

    // Redirect to the homepage after a delay of 1.5 seconds (1500 milliseconds)
    window.setTimeout(function () {
      window.location.href = "/";
    }, 1500);
  }

  // Method to get the user's current location and calculate the distance from the store
  getLocation(longitude: string, latitude: string): Promise<any> {
    // Return a promise to handle asynchronous location retrieval
    return new Promise((resolve, reject) => {
      let Distance: number;
      let userlatitude: number;
      let userlongitude: number;

      // Check if geolocation is supported by the browser
      if (navigator.geolocation) {
        // Get the current position
        navigator.geolocation.getCurrentPosition(
          (position) => {
            userlatitude = position.coords.latitude;
            userlongitude = position.coords.longitude;
            const Flongitude = position.coords.longitude;
            const Flatitude = position.coords.latitude;
            const Slongitude = longitude;
            const Slatitude = latitude;
            Distance =
              Math.round(
                this._getDistanceFromLatLonInKm(
                  Flatitude,
                  Flongitude,
                  Slatitude,
                  Slongitude,
                ) * 100,
              ) / 100;
            resolve([Distance, userlatitude, userlongitude] as const);
          },
          function (error) {
            // Reject the promise and log the error message
            reject(error.message);
            console.log(error.message);
          },
        );
      }
    });
  }

  getUserLocation(longitude: string, latitude: string): Promise<any> {
    // Return a promise to handle asynchronous location retrieval
    return new Promise((resolve, reject) => {
      let userlatitude: number;
      let userlongitude: number;

      // Check if geolocation is supported by the browser
      if (navigator.geolocation) {
        // Get the current position
        navigator.geolocation.getCurrentPosition(
          (position) => {
            userlatitude = position.coords.latitude;
            userlongitude = position.coords.longitude;
            const Flongitude = position.coords.longitude;
            const Flatitude = position.coords.latitude;
            const Slongitude = longitude;
            const Slatitude = latitude;

            resolve([userlatitude, userlongitude] as const);
          },
          function (error) {
            // Reject the promise and log the error message
            reject(error.message);
            console.log(error.message);
          },
        );
      }
    });
  }

  // Method to format amount with dynamic decimal places
  formatCurrency(amount: number, currencyDecimals: number): string {
    if (amount === null || amount === undefined) {
      return "";
    }

    // If currency_decimals is missing, default to 2
    let decimals = currencyDecimals ?? 2;

    // Format the number with the specified decimal places
    return amount.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  // Method to convert amount to cent as per country currency
  currencyConversion(amount: number, currencyCode: string): number {
    let fullvalue: Array<string> = [
      "BIF",
      "CLF",
      "DJF",
      "GNF",
      "ISK",
      "JPY",
      "KMF",
      "KRW",
      "PYG",
      "RWF",
      "UGX",
      "VUV",
      "VND",
      "XAF",
      "XOF",
      "XPF",
    ];
    let thousendvalue: Array<string> = [
      "BHD",
      "IQD",
      "JOD",
      "KWD",
      "LYD",
      "OMR",
      "TND",
    ];

    let result: number;

    if (fullvalue.includes(currencyCode.toUpperCase())) {
      result = amount;
    } else if (thousendvalue.includes(currencyCode.toUpperCase())) {
      result = amount * 1000;
    } else {
      result = amount * 100;
    }

    // Fix floating-point precision
    return Math.round(result);
  }

  // Method to calculate the user distance from the store
  _getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in kilometers
    var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in KM
    return d;
  }

  // Method to convert degrees to radians
  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  // Method to get Google Pay gateway object based on the GatewayKey
  GetGooglePayGatewayObject(GatewayKey: string, Key: string) {
    switch (GatewayKey) {
      case "checkout_v2": {
        return {
          gateway: "checkoutltd",
          gatewayMerchantId: Key,
        };
      }
      case "cyber_source": {
        return {
          gateway: "cybersource",
          gatewayMerchantId: Key,
        };
      }
      default: {
        return {
          gateway: "None",
          gatewayMerchantId: "",
        };
      }
    }
  }

  // Method to get the operating system of the device
  GetOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;
    // Check if the device is Android
    if (/android|X11/i.test(userAgent)) {
      return "a"; // 'a' denotes Android
    }

    // Check if the device is iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "i"; // 'i' denotes iOS
    }

    // Check if the device OS is Windows (For Laptop and PC)
    if (navigator.appVersion.indexOf("Win") != -1) {
      return "a"; // 'a' denotes Windows
    }

    // Check if the device OS is MAC (For Laptop and PC)
    if (navigator.appVersion.indexOf("Mac") != -1) {
      return "i"; // 'i' denotes MAC
    }
  }
}

// Enumerations used in the code
export enum AppType {
  restaurant_App = 0,
  Scan_in_store_App,
  Order_Online_App,
  Scan_Promotion_App,
  Book_Order_Online_App,
}

export enum OrderAppType {
  main_app = 1,
  webapp,
}

export enum CheckoutType {
  Take = "take",
  Collect = "collect",
  Serve = "serve",
  Book = "book",
  Deliver = "deliver",
}

export enum FulfillmentType {
  AssignTable = "assign_table",
  Table = "table",
  Waiter = "waiter",
  Room = "room",
  None = "none",
}

export enum PaymentMode {
  DirectCard = "pay_in_app_online",
  ApplePayGpay = "paid_with_apple_pay",
  Cash = "pay_cash",
  CardTerminal = "pay_by_card_terminal",
  ChargeToRoom = "charge_to_room",
  Toodle = "pay_with_toodle",
  Token = "paid_with_token",
  BankTransfer = "bank_transfer",
  BrunchPackage = "brunch_package",
  AllInclusive = "all_inclusive",
  FullBoard = "full_board",
  HalfBoard = "half_board",
  Entertainer = "the_entertainer",
  Groupon = "groupon",
  TotallyWicked = "pay_in_store_totally_wicked",
  PaymentLink = "payment_link",
}

export enum PaymentGatewayType {
  Stripe = "stripe",
  Braintree = "braintree",
  Checkout = "checkout_v2",
  CyberSource = "cyber_source",
  NI = "network_international",
}

export enum HomeScreenTemplate {
  StandardTemplate = 0,
  Grid3 = 1,
  Grid2 = 2,
}

export enum HomeScreenType {
  Standard = 0,
  MultiVenue = 1,
  Category = 2,
}

export enum PageName {
  Dashboard = 0,
  Category,
  SubCategory,
  Product,
  Basket,
  Checkout,
  Receipt,
  Home,
}

export enum MultiOutletLocation {
  FromMultiOutlet = 0,
  FromUser,
  HideDistance,
}
